module.exports = __webpack_public_path__ + "img/sv24.f5d9e583.svg";